import axios from "axios";
import { toast } from "react-toastify";

const Api = axios.create({
  baseURL: "https://rasad-api.havirard.ir",
});

// افزودن توکن دسترسی به هدر همه درخواست‌ها
Api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("app_havir");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// تابع رفرش توکن
const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("app_rt");
  if (!refreshToken) {
    throw new Error("رفرش توکن موجود نیست");
  }

  const response = await axios.post(
    "https://rasad-api.havirard.ir/refresh-token",
    { refresh_token: refreshToken },
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  // ذخیره توکن‌های جدید
  localStorage.setItem("app_havir", response.data.app_havir);
  if (response.data.app_rt) {
    localStorage.setItem("app_rt", response.data.app_rt);
  }
  return response.data.app_havir;
};

// اینترسپتور پاسخ برای مدیریت خطای ۴۰۱
Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return Api(originalRequest); // تلاش مجدد
      } catch (refreshError) {
        toast.error("نشست شما منقضی شده است، لطفاً دوباره وارد شوید");
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default Api;